import { createSelector } from 'reselect';
import { RootState } from '../state';

export const selectOrgHierarchyState= (state: RootState) => state?.orgHierarchy;

export const selectOrgHierarchyRootOrg = createSelector(
  selectOrgHierarchyState,
  (state) => state?.rootOrg,
);

export const selectOrgHierarchySelectedOrg = createSelector(
  selectOrgHierarchyState,
  (state) => state?.selectedOrg,
);

export const selectOrgHierarchyLoadingState = createSelector(
  selectOrgHierarchyState,
  (state) => state?.isLoading,
);

export const selectOrgHierarchyLoadedState = createSelector(
  selectOrgHierarchyState,
  (state) => state?.loaded,
);

export const selectOrgHierarchyActiveNode = createSelector(
  selectOrgHierarchyState,
  (state) => state?.activeNode,
);


export const selectOrgHierarchyErrorState = createSelector(
  selectOrgHierarchyState,
  (state) => state?.error,
);

export const selectOrgList = createSelector(
  selectOrgHierarchyState,
  (state) => state?.orgs,
);

export const selectOrgHierarchyCreatingState = createSelector(
  selectOrgHierarchyState,
  (state) => state?.creating,
);

export const selectOrgHierarchyCreatedState = createSelector(
  selectOrgHierarchyState,
  (state) => state?.created,
);
